import { getColumnToggleCookie } from '../../../../stores/algos-list-table-settings/reducers';
import { viewAlerts } from './alerts';
import { viewAlgoType } from './algoType';
import { viewEnabled } from './enabled';
import { viewErrorCount } from './errorCount';
import { viewMultiplier } from './multiplier';
import { viewStatus } from './status';
import { viewTransactionType } from './transactionType';
import { viewUnderlyingSymbols } from './underlyingSymbols';
import { viewCommon } from './viewCommon';

export const filterViewsAlgos = (data, viewsFilter, brokersDataAll) => {
  const toggleFields = getColumnToggleCookie();

  let searchData = [...data];

  if (viewsFilter.enabled) {
    searchData = viewEnabled(searchData, viewsFilter.enabled);
  }

  if (viewsFilter.status) {
    searchData = viewStatus(searchData, viewsFilter.status);
  }

  if (viewsFilter.algoStatus) {
    searchData = viewCommon('algoStatus', searchData, viewsFilter.algoStatus);
  }

  if (viewsFilter.broker) {
    searchData = viewCommon('broker', searchData, viewsFilter.broker);
  }

  if (viewsFilter.alerts) {
    searchData = viewAlerts(searchData, viewsFilter.alerts, brokersDataAll);
  }

  if (toggleFields?.startTime !== false && viewsFilter.startTime) {
    searchData = viewCommon('startTime', searchData, viewsFilter.startTime);
  }

  if (toggleFields?.endTime !== false && viewsFilter.endTime) {
    searchData = viewCommon('endTime', searchData, viewsFilter.endTime);
  }

  if (toggleFields?.tradingType !== false && viewsFilter.tradingType) {
    searchData = viewCommon('tradingType', searchData, viewsFilter.tradingType);
  }

  if (viewsFilter.multiplier) {
    searchData = viewMultiplier(searchData, viewsFilter.multiplier);
  }

  if (viewsFilter.type) {
    searchData = viewAlgoType(searchData, viewsFilter.type);
  }

  if (
    toggleFields?.underlyingSymbols !== false &&
    viewsFilter.underlyingSymbols
  ) {
    searchData = viewUnderlyingSymbols(
      searchData,
      viewsFilter.underlyingSymbols
    );
  }

  if (toggleFields?.transactionType !== false && viewsFilter.transactionType) {
    searchData = viewTransactionType(searchData, viewsFilter.transactionType);
  }

  if (toggleFields?.entryErrorCount !== false && viewsFilter.entryErrorCount) {
    searchData = viewErrorCount(
      'entryErrorCount',
      searchData,
      viewsFilter.entryErrorCount
    );
  }

  if (toggleFields?.exitErrorCount !== false && viewsFilter.exitErrorCount) {
    searchData = viewErrorCount(
      'exitErrorCount',
      searchData,
      viewsFilter.exitErrorCount
    );
  }

  return searchData;
};
